module.exports = __webpack_public_path__ + "img/blue-ticket-purchase-confirmation.ba3016b2.svg";